// 接入小程序预请求的prod_key
export const PRE_INIT_LIST = ['ut-dunion-wyc']

// 关闭sw
export const DISABLE_SW_LIST = ['ut-dunion-car']

export const ENTRY_TYPE = {
  else: 0,
  formCopyLink: 1,
}

export const HOME_PAGE_SHOW_ENUM = {
  error: 0, // 非正常活动露出
  normal: 1, // 正常活动露出
}
